export const WEB_CONFIG: any = {
    // base_url: "http://localhost:3000",
    // base_url: "https://deeperks-admin-dev.web.app",
    base_url: "https://admin.deeperks.com",
    marketplace_base_url: "https://deeperks-marketplace-dev.web.app"
    // firebase deploy  --only hosting:deeperks-admin-dev
}